<div
  data-at-dashboard
  class="dashboard flex flex-col gap-[20px] lt-md:gap-[16px] justify-start items-start"
>
  <app-generic-info-banner></app-generic-info-banner>
  <!-- Domain change - deletion recommended -->
  <div
    class="banner"
    *ngIf="isAllowedUser && (remoteConfigStore.isBannerVisible(roadshowBanner) | async)"
  >
    <button
      data-at-close-banner
      mat-icon-button
      gtm="onOpen"
      gtmAction="Banner"
      gtmCategory="installationDashboard"
      (click)="onBannerClose(roadshowBanner)"
      class="banner-btn--close"
    >
      <mat-icon>close</mat-icon>
    </button>
    <a
      rel="noreferrer"
      href="https://live.viessmann-climatesolutions.com/de/roadshow.html?utm_source=interner-tp&utm_medium=viguidet&utm_campaign=_de_ish_roadshow"
      target="_blank"
    >
      <img class="!hidden lt-md:!inline" src="/assets/img/banner-ish-roadshow-mobile.jpg" />
      <img class="lt-md:!hidden" src="/assets/img/banner-ish-roadshow-desktop.jpg" />
    </a>
  </div>

  <!-- Domain change - deletion recommended -->
  <div
    class="banner"
    *ngIf="isAllowedUser && (remoteConfigStore.isBannerVisible(testiegerBanner) | async)"
  >
    <button
      data-at-close-banner
      mat-icon-button
      gtm="onOpen"
      gtmAction="Banner"
      gtmCategory="installationDashboard"
      (click)="onBannerClose(testiegerBanner)"
      class="banner-btn--close"
    >
      <mat-icon>close</mat-icon>
    </button>
    <a
      rel="noreferrer"
      href="https://partnerportal.viessmann-climatesolutions.com/de/de/informieren/neuigkeiten/sommer-kampagne.html"
      target="_blank"
    >
      <img class="!hidden lt-md:!inline" src="/assets/img/banner-ish-testieger-mobile.png" />
      <img class="lt-md:!hidden" src="/assets/img/banner-ish-testieger-desktop.png" />
    </a>
  </div>

  <ng-container
    *ngIf="remoteConfigStore.isBannerVisible(isNotAbleToHandleAllRequestsBannerVisible) | async"
  >
    <app-banner>
      {{ 'NOT_ABLE_TO_HANDLE_REQUESTS_BANNER.TITLE' | translate }}
    </app-banner>
  </ng-container>

  <div
    class="e3-marketlaunch-banner"
    *ngIf="remoteConfigStore.isE3HeatPumpMarketLaunchBannerVisible$ | async"
  >
    <a rel="noreferrer" href="https://track.adform.net/C/?bn=53377267" target="_blank">
      <img src="/assets/img/e3heatpumpmarketlaunch-horizontal.png" />
    </a>
  </div>

  <!-- Domain change - deletion recommended -->
  <ng-container *ngIf="remoteConfigStore.isLearningRoomBannerAvailable$ | async">
    <app-learning-space-banner
      *ngIf="authStore.isLearningRoomVisible() | async"
    ></app-learning-space-banner>
  </ng-container>

  <div
    class="event-banner"
    *ngIf="remoteConfigStore.isNewVitoguideFeaturesBannerAvailable$ | async"
  >
    <app-event-banner></app-event-banner>
  </div>

  <div class="event-banner" *ngIf="remoteConfigStore.isPaidFeaturesBannerAvailable$ | async">
    <app-paid-features-banner></app-paid-features-banner>
  </div>

  <ng-container
    *ngIf="
      (remoteConfigStore.isBannerVisible(bannerForEndCustomer) | async) &&
      (authStore.isEndUser$ | async)
    "
  >
    <app-banner type="info" [title]="'+INSTALLATIONS.NOTIFICATIONS.BANNER.EK_TITLE' | translate">
      <p [innerHTML]="'+INSTALLATIONS.NOTIFICATIONS.BANNER.EK_INFO' | translate | viTrustHtml"></p>
    </app-banner>
  </ng-container>

  <ng-container
    *ngIf="
      isUserFromGermanyOrAustria &&
      (remoteConfigStore.isBannerVisible(advertisingBannerForDeAndAu) | async) &&
      (backendStorageStore.advertBannerVisibility$ | async)
    "
  >
    <div class="advert-banner flex flex-row">
      <img class="advert-banner__img lt-md:!hidden" src="assets/img/banner-advert-DE-AU.png" />

      <div class="flex flex-col advert-banner__wrapper">
        <div class="flex flex-row justify-between">
          <h2>
            {{ '+INSTALLATIONS.NOTIFICATIONS.BANNER_ADVERT.TITLE' | translate }}
          </h2>
          <button
            mat-icon-button
            gtm="onOpen"
            gtmAction="Banner"
            gtmCategory="installationDashboard"
            (click)="onAdvertBannerClose()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div
          class="advert-banner__info"
          [innerHTML]="'+INSTALLATIONS.NOTIFICATIONS.BANNER_ADVERT.INFO' | translate | viTrustHtml"
        ></div>

        <a
          class="advert-banner__link"
          mat-stroked-button
          rel="noreferrer"
          [href]="advertBannerLink"
          target="_blank"
        >
          <span>
            {{ '+INSTALLATIONS.NOTIFICATIONS.BANNER_ADVERT.NAVIGATE' | translate }}
          </span>
          <mat-icon iconPositionEnd>arrow_forward</mat-icon>
        </a>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="remoteConfigStore.isBannerVisible(vitoconnectIssueBanner) | async">
    <app-banner
      type="info"
      [title]="'+INSTALLATIONS.NOTIFICATIONS.BANNER.VITOCONNECT_TITLE' | translate"
      [linkLabel]="'+INSTALLATIONS.INSTALLATIONS.ANNOUNCEMENT_BANNER.MORE_INFORMATION' | translate"
      [link]="vitoconnectLink"
      linkGtm="onGoToPage"
    >
      {{ '+INSTALLATIONS.NOTIFICATIONS.BANNER.VITOCONNECT_INFO' | translate }}
    </app-banner>
  </ng-container>

  <ng-container *ngIf="bookingStore.hasAccessToBooking$ | async">
    <ng-container
      *ngIf="
        (bookingStore.contingentSubscriptions$ | async)?.length as contingentSubscriptionsAmount
      "
    >
      <app-banner
        *ngIf="isHardwareBundlingAvailable"
        [linkLabel]="'BUNDLING_BANNER.BUTTON.SHOW_DETAILS' | translate"
        [linkForRouter]="'/booking-overview'"
        [title]="
          (contingentSubscriptionsAmount === 1
            ? 'BUNDLING_BANNER.DESCRIPTION.PURCHASED_PACKAGE'
            : 'BUNDLING_BANNER.DESCRIPTION.PURCHASED_PACKAGES'
          ) | translate: { packagesAmount: contingentSubscriptionsAmount }
        "
        linkGtm="onGoToPage"
        linkGtmAction="Open booking overview"
        linkGtmCategory="bookingOverview"
      >
        {{
          (contingentSubscriptionsAmount === 1
            ? 'BUNDLING_BANNER.DESCRIPTION.ACTIVATE_PACKAGE'
            : 'BUNDLING_BANNER.DESCRIPTION.ACTIVATE_PACKAGES'
          ) | translate
        }}
      </app-banner>
    </ng-container>

    <app-banner
      *ngIf="
        (bookingStore.automaticExtensionSubscriptionsEndingSoon$ | async).length as numberOfPackages
      "
      [title]="
        '+INSTALLATIONS.INSTALLATIONS.AUTOMATIC_EXTENSION_BANNER.HEADER'
          | translate: { number: numberOfPackages }
      "
      [linkLabel]="'+BOOKING.GO_TO_BOOKING_OVERVIEW' | translate"
      [linkForRouter]="'/booking-overview'"
      linkGtm="onGoToPage"
      linkGtmAction="Open booking overview"
      linkGtmCategory="bookingOverview"
    >
      {{ '+INSTALLATIONS.INSTALLATIONS.AUTOMATIC_EXTENSION_BANNER.DESCRIPTION' | translate }}
    </app-banner>

    <app-banner
      *ngIf="(bookingStore.trialSubscriptionsActiveEndingSoon$ | async).length as numberOfPackages"
      [title]="
        '+INSTALLATIONS.INSTALLATIONS.TRIAL_BANNER.HEADER' | translate: { number: numberOfPackages }
      "
      [linkLabel]="'+INSTALLATIONS.INSTALLATIONS.TRIAL_BANNER.LINK' | translate"
      [linkForRouter]="'/booking-overview'"
      linkGtm="onGoToPage"
      linkGtmAction="Open booking overview"
      linkGtmCategory="bookingOverview"
      >{{ '+INSTALLATIONS.INSTALLATIONS.TRIAL_BANNER.DESCRIPTION' | translate }}</app-banner
    >
  </ng-container>

  <div data-at-description class="flex flex-col gap-[6px] flex-auto">
    <vi-text data-at-description-company-name *ngIf="companyName" color="light" size="medium">{{
      companyName | truncate: companyNameLengthLimit
    }}</vi-text>
    <div class="title-wrapper">
      <h2 data-at-description-headline>
        {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.HEADLINE' | translate }}
      </h2>

      <button mat-stroked-button>
        <a
          class="link flex flex-row justify-start items-center"
          gtm="onGoToPage"
          gtmAction="Map"
          gtmCategory="sidenav"
          [routerLink]="['/installations/map']"
          routerLinkActive="active"
        >
          <mat-icon>map</mat-icon> <span>{{ 'SHARED.SIDENAV.MAP_LINK_TITLE' | translate }}</span>
        </a>
      </button>
    </div>
  </div>
</div>
